import { createSlice } from '@reduxjs/toolkit'

export const onLoadCurriculumsReducer = (state, { payload }) => {
  const { curriculums } = payload

  const newState = {
    ...state,
    curriculums
  }
  return newState
}

export const onSaveCurriculumReducer = (state, { payload }) => {
  const { curriculum } = payload
  const newState = {
    ...state,
    curriculum
  }
  return newState
}

const curriculumSlice = createSlice({
  name: 'curriculum',
  initialState: {
    curriculums: [],
    curriculum: null
  },
  reducers: {
    onLoadCurriculums: onLoadCurriculumsReducer,
    onSaveCurriculum: onSaveCurriculumReducer
  }
})

const { actions, reducer } = curriculumSlice

export const {
  onLoadCurriculums,
  onSaveCurriculum
} = actions

export default reducer
